import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';
import { CreateCalendarEventActionService } from './create-calendar-event-action.service';

@NgModule({
  imports: [CommonModule, ComponentsModule],
  providers: [CreateCalendarEventActionService],
})
export class NgCalendarCoreModule {}
